import { toast } from "react-toastify";

const CustomToast = {
    success: (message, toastTime = 5000) => {
        console.log("Toast success", message);
        return toast.success(message, {
            position: "top-right",
            autoClose: toastTime,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
        });
    },
    warn: (message, toastTime = 2000) => {
        console.log("Toast warn", message);
        return toast.warn(message, {
            position: "top-right",
            autoClose: toastTime,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
        });
    },
    error: (message, toastTime = 7000) =>
        toast.error(message, {
            position: "top-right",
            autoClose: toastTime,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
        }),
    info: (message, toastTime = 5000, showClose = true, icon = null, options) =>
        toast.info(message, {
            ...options,
            position: "top-right",
            autoClose: toastTime,
            hideProgressBar: true,
            closeOnClick: showClose,
            closeButton: showClose,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            icon: icon,
            theme: "dark",
        }),
    loading: (message, toastTime = 5000, showClose = true) => {
        return toast.loading(message, {
            position: "top-right",
            autoClose: toastTime,
            hideProgressBar: true,
            closeOnClick: showClose,
            closeButton: showClose,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
        });
    },
    default: (message, options) => {
        return toast(message, {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            pauseOnHover: false,
            closeButton: false,
            closeOnClick: false,
            className: "toast-notification-message-box",
            draggable: false,
            progress: undefined,
            ...options,
            onClose: (removedByUser) => {
                if (removedByUser) return; // for manually close the toast
                options.onClose(options.data); // for handle auto-close case
            },
        });
    },
    promise: (promiseFunction, details) => {
        return toast.promise(promiseFunction, details, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
        });
    },
    getToastType: (toastObj) => {
        return toast.isActive(toastObj) ? toast(toastObj).type : null;
    },
    dismissToast: (toastObj) => {
        toast.dismiss(toastObj);
    },
};

export default CustomToast;
